import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'

import { NavBar } from 'components/NavBar/NavBar'
import { StepNumber } from 'pages/Accomodation/Accommodation.style'
import { BodyText } from 'styling/Typography'
import { NextIcon } from 'pages/Accomodation/icons/NextIcon'
import { useState } from 'react'
import { Identity } from './Sections/Identity'
import { Scope } from './Sections/Scope'
import { Recurrence } from './Sections/Recurrence'
import { Bindings } from './Sections/Bindings'
import { Review } from './Sections/Review'


export const AddShiftProgram = () => {

    const [state, setState] = useState({})
    const [step, setStep] = useState(1)

    const handleSave = () => {
        return
    }

    const renderStep = () => {
        switch (step) {
            case 1:
                return <Identity state={state} setStep={setStep} setState={setState} />
            case 2:
                return <Scope state={state} setStep={setStep} setState={setState} />
            case 3:
                return <Recurrence state={state} setStep={setStep} setState={setState} />
            case 4:
                return <Bindings state={state} setStep={setStep} setState={setState} />
            case 5:
                return <Review state={state} setStep={setStep} setState={setState} handleSave={handleSave} />
        }
    }



    return <>
        <NavBar />
        <PageWrapper noFooter>
            <H1WithBack arrow title='Add Shift Program' />
            <Flex gap='1rem' center style={{ margin: '2rem 0' }} >
                <Step pointer step={1} name='Identity' active={step === 1} onClick={() => setStep(1)} />
                <NextIcon />
                <Step step={2} name='Scope' active={step === 2} />
                <NextIcon />
                <Step step={3} name='Recurrence' active={step === 3} />
                <NextIcon />
                <Step step={4} name='Bindings' active={step === 4} />
                <NextIcon />
                <Step step={5} name='Review' active={step === 5} />
                {/* <NextIcon />
                <Step step={3} name='Confirm' active={step === 3} /> */}
            </Flex>
            {renderStep()}
        </PageWrapper>
    </>
}

const Step = ({ step, name, active, onClick, pointer }: { step: number, name: string, active: boolean, onClick?: () => void, pointer?: boolean }) => {
    return <Flex center gap='1rem' onClick={onClick} style={{ cursor: pointer ? 'pointer' : 'default' }} >
        <StepNumber active={active} >  {step}</StepNumber>
        <BodyText grey={!active} >{name}</BodyText>
    </Flex>
}